import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { AREAS_USUARIOS } from "../../utils/constants";

export const areasTraerStart = () => ({ type: types.areasTraerStart });
export const areasLimpiar = () => ({ type: types.areasLimpiar });
export const areasTraerError = (error) => ({ type: types.areasTraerError,payload: error});
export const areasTraerSuccess = (payload) => {
    return {
        type: types.areasTraerSuccess,
        payload: payload
    }
}
export const areasUsuarioSeleccionado = (payload) => {
    return {
        type: types.areasUsuarioSeleccionado,
        payload: payload
    }
}
  
export const fetchAreas = () => {
    return async (dispatch) => {
        dispatch(areasTraerStart());
        const response = await fetchConToken(`areas`);
        if (!response.ok) {
            dispatch(areasTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(areasTraerSuccess(lista));
            }
        }
    };
};

export const fetchAreasUsuario = (idUsuario) => {
    return async (dispatch) => {
        dispatch(areasTraerStart());
        const response = await fetchConToken(`usuarioAreas/traerAreasUsuario/${ idUsuario }`);
        if (!response.ok) {
            dispatch(areasTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            
            dispatch( areasUsuarioSeleccionado(lista) );
        }
    };
};

export const setAreaUsuario = (idUsuario, idArea) => {
    return async (dispatch, getState) => {
        try{
            dispatch(areasTraerStart());
            const response = await fetchConToken(`usuarioAreas`, {idUsuario, idArea},'POST');
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const respuesta = await response.json();
                if (!response.ok) throw respuesta.errores;
                
                const state = getState();
                const { areasUsuarioSeleccionado: areasActuales } = state.areas;
                const nuevasAreas = [ ...areasActuales, respuesta ];

                dispatch( areasUsuarioSeleccionado(nuevasAreas) );

                if(idArea === AREAS_USUARIOS.MESA_ENTRADA) ;
            }
        } catch (err) {
            console.log( err );
            dispatch(startAlerta(err, "warning", `¡Error!`));
        }
    }; 
};

export const eliminarAreaUsuario = (idUserArea) => {
    return async (dispatch, getState) => {
        dispatch(areasTraerStart());

        const response = await fetchConToken(`usuarioAreas`, {idUserArea},'DELETE');
        if (!response.ok) {
            dispatch(areasTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const state = getState();
            const { areasUsuarioSeleccionado: areasActuales } = state.areas;
            const nuevasAreas = areasActuales.filter( s=> s.idUsuarioArea !== idUserArea)

            dispatch( areasUsuarioSeleccionado(nuevasAreas) );
        }
    };
};